// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";


// COMPONENTI
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";
import ServicesAccordion from "../Services/ServicsAccardion";

const Services: React.FC = () => {
    const { t } = useTranslation();

    const imagePath = '/assets/images/altrePag/subHeaderServizi.jpg';

    return (
        <>
            <Helmet>
                <title>{t('navigation.servicesLinkTitle')}</title>
            </Helmet>

            <SubHeaderDefault title={t('navigation.servicesLinkTitle')} isSeo={true} bg={imagePath} />

            <main id="page" className="services-page space-ptb">
                <div className="container-fluid">
                    <section className="mb-4">
                        <p>{t('servicesPage.section1.para1')}</p>
                        <p dangerouslySetInnerHTML={{ __html: t('servicesPage.section1.para2') as string }}></p>
                        <p dangerouslySetInnerHTML={{ __html: t('servicesPage.section1.para3') as string }}></p>
                        <p>{t('servicesPage.section1.para4')}</p>
                        <h3>{t('servicesPage.section1.subTitle')}</h3>
                        <p>{t('servicesPage.section1.para5')}</p>
                        <p dangerouslySetInnerHTML={{ __html: t('servicesPage.section1.para6') as string }}></p>
                    </section>
                    <ServicesAccordion />
                </div>
            </main>
        </>
    );
};

export default Services;